<template>
  <div id="service">   
    <CartComponent></CartComponent>     
  </div>
</template>

<script>

  import CartComponent from '@/components/cust_components/cart_component.vue';
  
  export default {
      name: 'CartView',
      data() {
          return {
          }
      },
      components: {     
        CartComponent,
      }
  }
</script>